import React from 'react';
import './Service.css';
const ServiceRow = ({ data }) => {
    return (
        <div className='flex items-center flex-col justify-center px-3 md:px-0  py-6 cursor-pointer bg-white shadow-xl transition duration-300 ease-in-out group border w-full service-effect duration-300 ease-in-out'>
            <h3 className='text-5xl sm:text-6xl text-gray-400 group-hover:text-gray-600 bg-gray-100 px-5 py-3 sm:p-5 rounded-lg'>{data.icon}</h3>
            <h3 className="text-2xl font-semibold mb-3 mt-1.5"></h3>
            <p className='text-gray-600 font-semibold text-center'>{data.title}</p>
            <p className='text-sm text-gray-400'>Over 301 Courses</p>
        </div>
    );
};

export default ServiceRow;